export { default } from "./tab";
